import React, { useEffect, useState } from "react";
import imagePlaceholder from "../../assets/images/image-placeholder.svg";

/**
 * Renders an image; if src is missing or fails to load, shows a placeholder.
 */
const SafeImage = ({
  src,
  alt = "",
  fallback,
  className,
  style,
  onError,
  ...rest
}) => {
  const placeholder = fallback || imagePlaceholder;
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  const showPlaceholder = !src || failed;

  return (
    <img
      src={showPlaceholder ? placeholder : src}
      alt={showPlaceholder ? "" : alt}
      className={className}
      style={style}
      onError={(e) => {
        if (!showPlaceholder) setFailed(true);
        onError?.(e);
      }}
      {...rest}
    />
  );
};

export default SafeImage;
export { imagePlaceholder };
